import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './styles.css';
import moment from 'moment';
import { selectReports, isLoading } from 'redux/slicers/reports';
import Table from '../../widgets/table/oldTable';
import Tooltip from '@material-ui/core/Tooltip';
import FilteringForm from './FilteringForm';

export const Reports = () => {
    const { report = {} } = useSelector(selectReports);
    const dispatch = useDispatch();

    return (
        <div className="cq-container">
            <FilteringForm report={report} />
            <div className="reportContainer">
                <Table {...tableBuilder()} rows={report.data || []} dataKey={report.key} isLoading={dispatch(isLoading('runConsoleReport'))} />
            </div>
        </div>
    );
};

function tableBuilder() {
    const style = { headerRow: { backgroundColor: '#14172c' }, bodyCell: { borderBottom: '1px solid #fe0072' } };
    const ellipsis = (val) => (val.length * 10 > 100 ? { overflow: 'hidden', textOverflow: 'ellipsis' } : {});
    const RenderBody = ({ column = {}, value = '' }) => {
        let cell = value;
        switch (column.id) {
            case 'endDate':
            case 'startDate':
                cell = moment(value).format('YYYY-MM-DD');
                break;
            case 'accountType':
                return <div style={{ color: '#000', width: 100 }}>{cell}</div>;
        }
        return (
            <Tooltip title={cell} disableHoverListener={!Object.keys(ellipsis(cell)).length}>
                <div style={{ color: '#000', whiteSpace: 'nowrap', maxWidth: 100, ...ellipsis(cell) }}>{cell}</div>
            </Tooltip>
        );
    };

    const RenderHead = ({ column }) => <div style={{ whiteSpace: 'nowrap' }}>{column.label}</div>;
    const RenderEmpty = () => <div className="noResultsText">NO DATA TO DISPLAY</div>;

    return {
        style,
        RenderBody,
        RenderHead,
        RenderEmpty,
    };
}

